(function () {
    'use strict';

    angular.module('app.layout', ['ui.router', 'app.account']);
})();